<div class="card-container">
  <mat-card class="card">
    <mat-card-footer>
      <mat-dialog-actions text-align="end">
        <mat-icon mat-dialog-close>close</mat-icon>
      </mat-dialog-actions>
    </mat-card-footer>

    @switch (whichGraph) {
      @case (1) {
        <p>Lead Fees</p>
      }
      @case (2) {
        <p>Bookings</p>
      }
      @case (3) {
        <p>Bookings per store</p>
      }

      @case (4) {
        @if (companyId === 20) {
          <p>Bookings MODULE vs. API</p>
        } @else {
          <p>Bookings per store (Ytd)</p>
        }
      }
      @default {
        <!-- Optional default content -->
        <p>Bookings per store (Ytd)</p>
      }
    }

    <mat-divider></mat-divider>

    <mat-card-content>
      <ng-container *ngIf="whichGraph === 1">
        <app-bar-chart
          [startDate]="startDate"
          [endDate]="endDate"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
        ></app-bar-chart>
      </ng-container>

      <ng-container *ngIf="whichGraph === 2">
        @if (companyId !== 20) {
          <app-line-chart
            [startDate]="startDate"
            [endDate]="endDate"
            [categoryIds]="categoryIds"
            [companyId]="companyId"
            apiType = "line"
          ></app-line-chart>
        } @else {
          <app-stacked-bar-chart
            [startDate]="startDate"
            [endDate]="endDate"
            [categoryIds]="categoryIds"
            [companyId]="companyId"
            apiType="stack"
          ></app-stacked-bar-chart>
        }
      </ng-container>

      <ng-container *ngIf="whichGraph === 3">
        @if (companyId === 20) {
          <app-single-bar-chart
            [startDate]="startDate"
            [endDate]="endDate"
            [categoryIds]="categoryIds"
            [companyId]="companyId"
            apiType="count"
          ></app-single-bar-chart>
        } @else {
          <app-stacked-bar-chart
            [startDate]="startDate"
            [endDate]="endDate"
            [categoryIds]="categoryIds"
            [companyId]="companyId"
            apiType="store"
          ></app-stacked-bar-chart>
        }
      </ng-container>

      <ng-container *ngIf="whichGraph === 4">
        @if (companyId === 20) {
          <app-line-chart
            [startDate]="startDate"
            [endDate]="endDate"
            [categoryIds]="categoryIds"
            [companyId]="companyId"
            apiType="bookingPercent"
          ></app-line-chart>
        } @else {
          <app-pie-chart
            [startDate]="startDate"
            [endDate]="endDate"
            [categoryIds]="categoryIds"
            [companyId]="companyId"
          ></app-pie-chart>
        }
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
